import { useMsal } from '@azure/msal-react';
import { azureLoginRequest } from '@returnoninvestment/hooks';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { Button } from '../../components/common';
import toast from '../../components/common/toast';

const Login = () => {
    const { push } = useHistory();
    const { instance } = useMsal();
    //const [{ username, password }, setState] = useState({ username: '', password: '' });

    const handleAdLogin = () => {
        instance
            .loginPopup(azureLoginRequest)
            .then((response) => {
                if (response.account) {
                    push('/');
                }
            })
            .catch((f) => {
                toast.error(
                    'Relay is currently unavaiable. Please try again later or contact support if this message persists.'
                );
            });
    };

    return (
        <div className="login-page">
            <div>
                {/* <div className="md:flex"> */}
                <div className="bg-white h-full sm:px-20 sm:py-12 p-12">
                    <div className="flex flex-col min-h-full">
                        <div className="lg:w-400 md:w-300 w-full flex flex-col gap-4 flex-grow justify-center">
                            {/* <span className="font-semibold mb-4 text-lg">Login</span> */}
                            {/* <div className="text-left font-bold text-xs">Username</div>
                <div className="">
                  <IconInput
                      className="text-sm rounded-lg"
                      border=""
                      dataTestId="email"
                      icon="users"
                      iconEnd
                      onChange={e => setState(state => ({ ...state, username: e.target?.value || '' }))}
                      placeholder="Enter your username or email"
                      required
                      type="email"
                      value={username}
                  />
                </div>
                <div className="text-left font-bold text-xs mt-3">Password</div>
                <div className="">
                  <IconInput
                      className="text-sm rounded-lg"
                      border=""
                      dataTestId="password"
                      icon="padlock"
                      iconEnd
                      onChange={e => setState(state => ({ ...state, password: e.target?.value || '' }))}
                      placeholder="Enter your password"
                      required
                      type="password"
                      value={password}
                  />
                </div>
                <div className="self-end">
                  <div className="text-xs underline font-medium cursor-pointer w-max">
                      Forgot password?
                  </div>
                </div>
                <Button
                  className="w-full text-sm mb-2 mt-3"
                  dataTestId="login-button"
                  onClick={() =>{}}   //generic handleLogin here for non AD sign in?
                  primary
                >
                  Login
                </Button>
                <div className="text-center text-xs text-gray-500">Or</div> */}
                            <Button type="primary" className="w-full" onClick={handleAdLogin}>
                                AD Sign In
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            {/* </div> */}
        </div>
    );
};

export default Login;
